import * as React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { Grid } from "@mui/material";
import { useApp } from "../hooks/useApp";
import { useNavigate } from "react-router-dom";

export default function Gobutton({ text, startIcon,endIcon, url, color,isActive=false }) {
  const {
    setOppyState,
    setActiveFactory,
    setActiveMegaFactory,
    selectedAsset,
    setActiveVideo,
    setActiveMockPc,
  } = useApp();
  const ColorButton = styled(Button)(({ theme }) => ({
    color: "secondary",
    backgroundColor:
      color && color.bg ? color.bg : theme.palette.secondary.main,
    "&:hover": {
      backgroundColor: theme.palette.info.main,
    },
  }));

  const navigate = useNavigate();

  const handleButtonClick = () => {
    if (url.type === "beacon") {
      window.open(url.url, "_blank");
    } else if (url === "oppy") {
      setOppyState((prev) => !prev);
    } else if (url === "factory") {
      setActiveFactory(selectedAsset);
    } else if (url === "megafactory") {
      setActiveMegaFactory(selectedAsset);
    } else if (url.type && url.type === "video") {
      setActiveVideo(url.url);
    } else if (url.type && url.type === "content") {
      window.open(url.url, "_blank");
    } else if (url.type === "mockpc") {
      setActiveMockPc(url.url);
    } else if (url.type === "assets") {
      navigate(url.url, {
        state: {
          selectedAsset: url.selectedAsset,
        },
      });
    }
  };
  return (
    <Grid item >
      <ColorButton className={`${isActive ? "active_route" : "inactive_route" }`}
        variant="contained"
        startIcon={startIcon}
        endIcon={endIcon}
        onClick={handleButtonClick}
      >
        {text}
      </ColorButton>
    </Grid>
  );
}
